'use strict';

var React = require('react'),
    PureRenderMixin = require('./PureRenderMixin');

var IconMixin = {
  mixins: [PureRenderMixin],

  propTypes: {
    size: React.PropTypes.oneOf(['small', 'medium', 'large']).isRequired
  },

  render: function () {
    var svg = this.renderSVG(this.props.size),
        viewBox;

    viewBox = {
      'small': '0 0 18 18',
      'medium': '0 0 32 32',
      'large': '0 0 48 48'
    };

    return (
      <span className='Icon-container' dangerouslySetInnerHTML={{__html: '<svg viewBox="' + viewBox[this.props.size] + '">' + svg + '</svg>'}} />
    );
  }
};

module.exports = IconMixin;


/** WEBPACK FOOTER **
 ** ./mixins/IconMixin.jsx
 **/